import { render, staticRenderFns } from "./MemoryPanel.vue?vue&type=template&id=06c55985&scoped=true&"
import script from "./MemoryPanel.vue?vue&type=script&lang=js&"
export * from "./MemoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./MemoryPanel.vue?vue&type=style&index=0&id=06c55985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c55985",
  null
  
)

export default component.exports